module.exports = __webpack_public_path__ + "img/1_uk.923d0de3.svg";